<template>
  <v-container>
    <v-row class="justify-center" >
      <v-col cols="md-8">
        <v-card
            v-if="survey_data"
            outlined
            class="mx-auto text-left rounded-t-lg"
        >
          <v-toolbar flat tile rounded="0" width="100%" color="super-grey" class="mb-0 pb-0">
            <slot name="title">
          <span class="text-h5">
            Опрос
          </span>
            </slot>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                    v-on="on"
                    fab
                    icon
                    small
                    @click="closeDetail"
                >
                  <v-icon>close</v-icon>
                </v-btn>
              </template>
              <span>Назад к списку</span>
            </v-tooltip>
          </v-toolbar>
          <SurveyingDetailTemplate :survey="survey_data"></SurveyingDetailTemplate>
          <v-card-actions>
            <v-spacer></v-spacer>
              <EmailCheckAttempt
                :survey-data="survey_data"
                :attempt-status="attempt_status"
                @continue="continueView"
              ></EmailCheckAttempt>
            <v-btn
                v-if="attempt_status === false"
                color="success"
                depressed
                @click="openSurveying"
                :loading="loading"
            >
              Начать опрос
            </v-btn>
            <v-btn
                v-if="attempt_status && attempt_ended === false"
                color="success"
                depressed
                @click="continueSurveying"
                :loading="loading"
            >
              Продолжить опрос
            </v-btn>
            <span
                v-if="attempt_status && attempt_ended === true"
                style="font-size: 20px; margin-top: -8px; padding-bottom: 10px"
            >
              Опрос пройден
            </span>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
        <v-card
            v-if="!survey_data && !loading"
            outlined
        >
          <v-toolbar flat tile rounded="0" width="100%" color="super-grey" class="mb-0 pb-0">
            <slot name="title">
              <span class="text-h5">
                Отказано в доступе!
              </span>
            </slot>
          </v-toolbar>
          <v-card-text>
            <p class="text-h6">
              Пожалуйста, авторизуйтесь в системе.<br>
              Данный опрос может быть недоступен в связи с отсутствием индивидуального
              приглашения или завершением срока прохождения опроса.
            </p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                depressed
                @click="closeDetail"
            >
              Вернуться к списку
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import {mapActions, mapGetters} from "vuex";
import names from "../routers/names";
import FormErrorsMixin from "@/mixins/FormErrorsMixin";
import EmailCheckAttempt from "@/modules/survey/surveys/EmailCheckAttempt.vue";
import SurveyingDetailTemplate from "@/modules/survey/surveys/SurveyingDetailTemplate.vue";
export default {
  name: "LinkDetail",
  components: {SurveyingDetailTemplate, EmailCheckAttempt},
  mixins:[
    FormErrorsMixin
  ],
  data(){
    return {
      email: undefined,
      survey_data: undefined,
      attempt_status: undefined,
      attempt_check: undefined,
      attempt_ended: undefined,
      available: false,
      loading: false,
      anonym_status: false,
    }
  },
  computed: {
    names: () => names,
    ...mapGetters({
      isAuthenticate: 'auth/isAuthenticated'
    }),
  },
  methods: {
    ...mapActions({
      LoadSurveyDetail: 'surveying/LoadSurveyDetail',
      createAttempt: "surveying/createAttempt",
    }),
    initialize() {
      this.loading = true
      this.LoadSurveyDetail({
        survey_id: this.$route.params.idSurvey,
        key: this.$route.query.key ? this.$route.query.key : null,
        finalizer:(val)=>{
          this.loading = false
          this.survey_data = val
        },
        catcher: (err) => {
          this.loading = false
          this.survey_data = null
        }
          }
      )
    },
    continueView(attemptCheck){
      this.attempt_status = attemptCheck.attempt_status
      this.attempt_ended = attemptCheck.attempt_ended
      this.available = attemptCheck.available
      this.attempt_check = attemptCheck
    },
    openSurveying() {
      this.loading = true;
      this.createAttempt({
        data: {
          survey: this.$route.params.idSurvey,
          user: this.attempt_check.surveying_person ? this.attempt_check.surveying_person : undefined,
          created: true,
          ended: false,
          is_anonym: this.anonym_status,
        },
        key: this.$route.query.key ? this.$route.query.key : null,
        finalizer: (val) => {
          this.loading = false;
          let queryParam = {}
          if (val.attempt_hash){
            queryParam = {
              attempt_hash:val.attempt_hash
            }
          }
          this.$router.push({
            name: names.SURVEYS.SURVEYING,
            params: {
              idSurvey: this.$route.params.idSurvey,
              idAttempt: val.id,
              attempt: val,
              key: this.$route.query.key ? this.$route.query.key : null,
            },
            query:queryParam
          })
        },
        catcher:(val) => {
          this.loading = false;
          this.errors.non = [];
          this.mapErrors(val);
        }
      })
    },
    continueSurveying(){
      this.$router.push({
        name: names.SURVEYS.SURVEYING,
        params: {
          idSurvey: this.$route.params.idSurvey,
          idAttempt: this.attempt_check.attempt,
          attempt: undefined
        },
        query:{
          attempt_hash: this.attempt_check.attempt_hash
        }
      })
    },
    closeDetail() {
      this.$router.push({
        name: names.SURVEYS.LIST,
      })
    },
  },
  created() {
    this.initialize()
  },
}
</script>

<style scoped>

</style>
